import { render, staticRenderFns } from "./OtherCompanyConstructionList.vue?vue&type=template&id=52c39148&scoped=true&"
import script from "./OtherCompanyConstructionList.vue?vue&type=script&lang=ts&"
export * from "./OtherCompanyConstructionList.vue?vue&type=script&lang=ts&"
import style0 from "./OtherCompanyConstructionList.vue?vue&type=style&index=0&id=52c39148&lang=scss&scoped=true&"
import style1 from "./OtherCompanyConstructionList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52c39148",
  null
  
)

export default component.exports